import { Box, TextField, Typography, Grid } from "@mui/material";

import { Controller, useForm } from "react-hook-form";
import RoadCars from "../images/roadCars.jpg";
import { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import {
  confirmation_EN,
  confirmation_FR,
  newContact_EN,
  newContact_FR,
} from "../utils/email";
import { IForm } from "../interfaces/contactVivia";
import { LoadingButton } from "@mui/lab";
const ViviaContact = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [loadingButton, setLoadingButton] = useState(false);
  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<IForm>();

  const newRequest = async (data: IForm) => {
    setLoadingButton(true);
    let text;
    let textContact;
    if (i18n.language === "fr") {
      text = confirmation_FR(data.name);
      textContact = newContact_FR(data);
    } else {
      text = confirmation_EN(data.name);
      textContact = newContact_EN(data);
    }
    const subjectNew = t("Nouvelle demande de contact") + " " + data.name;
    const subjectConfirmation = t(`Merci de nous avoir contactés.`);
    await emailjs
      .send(
        "service_17uejwg", // trouvé dans EmailJS > Email Services
        "template_newContact", // trouvé dans EmailJS > Email Templates
        {
          text: textContact,
          subjectEmail: subjectNew,
        },
        "fyRV_pkC85mOM6uCo" // trouvé dans EmailJS > Account > API Keys
      )
      .then(() => {
        toast.success("Votre demande a ètè envoyée", {
          // position: "top-center",
          theme: "dark",
          autoClose: 3000, // 3 seconds
        });
      })
      .catch((err) => {
        toast.error(
          "Une erreur inattendue s'est produite. Veuillez réessayer plus tard",
          {
            // position: "top-center",
            theme: "dark",
            autoClose: 3000, // 3 seconds
          }
        );
      });
    emailjs
      .send(
        "service_17uejwg", // trouvé dans EmailJS > Email Services
        "template_confirmation", // trouvé dans EmailJS > Email Templates
        {
          email: data.email,
          text,
          subjectEmail: subjectConfirmation,
        },
        "fyRV_pkC85mOM6uCo" // trouvé dans EmailJS > Account > API Keys
      )
      .then(() => {})
      .catch((err) => {
        toast.error(
          "Une erreur inattendue s'est produite. Veuillez réessayer plus tard",
          {
            // position: "top-center",
            theme: "dark",
            autoClose: 3000, // 3 seconds
          }
        );
      });
    reset({
      name: "",
      email: "",
      companyName: "",
      subject: "",
    });
    setLoadingButton(false);
  };
  return (
    <Box
      ref={ref}
      sx={{
        backgroundImage: ` url(${RoadCars})
    `,
        flexDirection: { xs: "column", lg: "row" },
        scrollMarginTop: "80px",
        backgroundSize: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "inset 0 0 0 1000px rgba(8, 21, 37, 0.8)",
        width: "100%",
        height: { xs: "100%", lg: "50%" },
        gap: { xs: 5, lg: 20 },
        pt: 2,
        pb: 3,
      }}
    >
      <Grid display="flex" flexDirection="column" gap={2}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontWeight: 800,
            fontSize: "30px",
            lineHeight: "40px",
            letterSpacing: "0%",
            textAlign: { xs: "center", md: "left" },
            verticalAlign: "middle",
            maxWidth: 340,
            color: " #FFF",
          }}
        >
          {t("Contact Us ? We're here to help!")}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "24px",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "middle",

            color: " #FFF",
          }}
        >
          {t("Send us a message and our team will get back to you shortly.")}
        </Typography>
      </Grid>
      <Grid display="flex" flexDirection="column" gap={3}>
        <Grid
          display="flex"
          gap={3}
          flexDirection={{ xs: "column", md: "row" }}
        >
          <Controller
            control={control}
            name="name"
            rules={{ required: true }}
            render={({ field: { onChange, value = "" } }) => (
              <TextField
                {...register("name", {
                  required: "Saisir votre nom",
                })}
                size="small"
                type="text"
                placeholder={t("Name")}
                id="outlined-basic"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    background: "#FFF",
                    // border: " 1px solid #E2E2E2",
                  },
                }}
                value={value}
                onChange={(event: any) => {
                  onChange(event);
                }}
                error={errors?.name ? true : false}
                helperText={errors?.name?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="subject"
            rules={{ required: true }}
            render={({ field: { onChange, value = "" } }) => (
              <TextField
                {...register("subject", {
                  required: "Saisir le sujet",
                })}
                size="small"
                multiline
                type="text"
                placeholder={t("Subject")}
                id="outlined-basic"
                sx={{
                  maxHeight: "15vh",

                  overflow: "auto",
                  "& .MuiOutlinedInput-root": {
                    background: "#FFF",
                    // border: " 1px solid #E2E2E2",
                  },
                }}
                value={value}
                onChange={(event: any) => {
                  onChange(event);
                }}
                error={errors?.subject ? true : false}
                helperText={errors?.subject?.message}
              />
            )}
          />
        </Grid>
        <Grid
          display="flex"
          gap={3}
          flexDirection={{ xs: "column", md: "row" }}
        >
          <Controller
            control={control}
            name="email"
            rules={{ required: true }}
            render={({ field: { onChange, value = "" } }) => (
              <TextField
                {...register("email", {
                  required: "Saisir votre email",
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Verifier votre email",
                  },
                })}
                size="small"
                type="text"
                placeholder={t("E-mail adress")}
                id="outlined-basic"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    background: "#FFF",
                    // border: " 1px solid #E2E2E2",
                  },
                }}
                value={value}
                onChange={(event: any) => {
                  onChange(event);
                }}
                error={errors?.email ? true : false}
                helperText={errors?.email?.message}
              />
            )}
          />

          <Controller
            control={control}
            name="companyName"
            rules={{ required: true }}
            render={({ field: { onChange, value = "" } }) => (
              <TextField
                {...register("companyName", {
                  required: false,
                })}
                size="small"
                type="text"
                placeholder={t("Company Name")}
                id="outlined-basic"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    background: "#FFF",
                    // border: " 1px solid #E2E2E2",
                  },
                }}
                value={value}
                onChange={(event: any) => {
                  onChange(event);
                }}
              />
            )}
          />
        </Grid>
        <Grid container justifyContent="flex-end">
          <LoadingButton
            sx={{
              color: "#FFF",
              border: "1px solid #28D1B4",
              bgcolor: " #33BBA4",
              pl: 4,
              pr: 4,
            }}
            loading={loadingButton}
            onClick={handleSubmit(newRequest)}
          >
            {t("Send")}
          </LoadingButton>
        </Grid>
      </Grid>
    </Box>
  );
});
export default ViviaContact;
